import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/randa-player-portals/app/_app/BodyClassesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccessGate"] */ "/app/apps/randa-player-portals/common/AccessGate.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/randa-player-portals/common/PageRender.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/auth-client/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/auth-client/src/contexts/AuthProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/auth-client/src/contexts/authProviderMethods.ts");
;
import(/* webpackMode: "eager" */ "/app/libs/auth-client/src/contexts/PlayerPortal/PPAuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/auth-client/src/contexts/PlayerPortal/PPAuthProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/auth-client/src/contexts/site-config/index.ts");
;
import(/* webpackMode: "eager" */ "/app/libs/common-ui/src/index.ts");
;
import(/* webpackMode: "eager" */ "/app/libs/utils/src/lib/config-utils/projectType.ts");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
